<template>
  <div>
    <LabInfo></LabInfo>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
const LabInfo = defineAsyncComponent(() => import("@/components/labs/LabInfo"));
export default {
  components: {
    LabInfo,
  },
};
</script>

<style></style>
